<template>
  <div id="voids">
    <PageTitle :title="$t('pos.voids')" :subtitle="$t('pos.voids_description')"></PageTitle>
    <div class="container">
      <Panel :showTitle="false">
        <Datatable entity="sale_item_void" :parameters="parameters"></Datatable>
      </Panel>
    </div>
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import PageTitle from "@/components/PageTitle.vue";

  export default {
    name: "Voids",
    components: { Datatable, PageTitle },
    data() {
      return {
        parameters: {
          company: this.$route.query.company
        }
      };
    }
  };
</script>
